'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToAmlStatus = exports.mapToKycStatus = void 0;
var getAmlStatus_1 = require("../adapter/users/getAmlStatus");
var getProfile_1 = require("../adapter/users/getProfile");
function mapToKycStatus(status) {
    switch (status) {
        case 'Verified':
            return getProfile_1.DocumentVerificationStatus.APPROVED;
        case 'VerifiedPartial':
            return getProfile_1.DocumentVerificationStatus.PROCESSING;
        case 'Failed':
            return getProfile_1.DocumentVerificationStatus.REJECTED;
        default:
            return getProfile_1.DocumentVerificationStatus.PENDING;
    }
}
exports.mapToKycStatus = mapToKycStatus;
function mapToAmlStatus(status) {
    switch (status) {
        case 'Verified':
            return getAmlStatus_1.AmlStatus.APPROVED;
        case 'VerifiedPartial':
            return getAmlStatus_1.AmlStatus.VERIFIED_PARTIAL;
        case 'Failed':
        case 'Rejected':
            return getAmlStatus_1.AmlStatus.REJECTED;
        case 'Pending':
            return getAmlStatus_1.AmlStatus.PROCESSING;
        case 'Requested':
            return getAmlStatus_1.AmlStatus.REQUESTED;
        case 'Expired':
            return getAmlStatus_1.AmlStatus.EXPIRED;
        case 'NotMatched':
            return getAmlStatus_1.AmlStatus.REJECTED;
        case 'NotSet':
            return getAmlStatus_1.AmlStatus.NOT_SET;
        default:
            return getAmlStatus_1.AmlStatus.NOT_SET;
    }
}
exports.mapToAmlStatus = mapToAmlStatus;
